import React from 'react'
import { Link } from 'react-router-dom'

const ArticleCard = (props) => (
    <Link to={`/cop/${props.id}`}>
        <div className='card' style={{ borderRadius: '30px', backgroundColor: '#F5F7F7', overflow: 'hidden', height: '100%', padding: '1.5rem' }}>
            <div className='card-img-top' style={{ 
                    height: '260px', 
                    backgroundImage: `url(${props.upload_thumbnail})`, 
                    backgroundSize: 'cover', 
                    backgroundPosition: 'center',
                    borderTopLeftRadius: '12px',
                    borderTopRightRadius: '12px',
                    borderBottomLeftRadius: '12px',
                    borderBottomRightRadius: '12px'
                }}>
            </div>
            <div className='card-body' style={{ padding: '0' }}>
                <p className='fs-7 fw-bold text-primary mb-1 mt-2' style={{ textTransform: 'uppercase' }}>{props.kategori}</p>
                <h5 className='card-title text-gray-800' style={{ textTransform: 'unset' }}>{props.judul}</h5>
                <div 
                    className='card-text fs-7 mb-1 text-gray-800' 
                    style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                    dangerouslySetInnerHTML={{ __html: props.abstrak }}
                />
                <div className='d-flex align-items-center justify-content-start'>
                    <Link to={`/cop/${props.id}`} className='fs-7 fw-bold' style={{ color: '#F95E2F' }}>Lihat Selengkapnya</Link>
                </div>
            </div>
        </div>
    </Link>
)

export default ArticleCard